import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { Typography, Stack, Button } from '@mui/material';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export const LisAddTestItemForm = ({ onClose, onAdd, testItemDropdown = [] }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        test_item_name: Yup.string().required('Item Name is required'),
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;
  const formSubmitHandler = (formValues) => {
    onAdd(formValues);
    reset();
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmitHandler)}>
      <Stack sx={{ p: 1.5, minWidth: '35rem' }} spacing={2}>
        <Stack spacing={0.5} direction="row" alignItems="center">
          <Typography sx={{ flex: 0.2 }}>Item Name</Typography>
          <SelectTag
            formControlSX={{ flex: 0.8 }}
            name="test_item_name"
            menus={testItemDropdown.map((data) => ({ ...data, value: data._id, name: data.test_item_name }))}
            placeholder="Select Test Item"
          />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center">
          <Typography sx={{ flex: 0.2 }}>Res Formula</Typography>
          <TextField sx={{ flex: 0.8 }} name="res_formula" inputProps={{ min: 0 }} />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center">
          <Typography sx={{ flex: 0.2 }}>Variable</Typography>
          <TextField sx={{ flex: 0.8 }} name="var" inputProps={{ min: 0 }} />
        </Stack>
        <Stack sx={{ flex: 1 }} spacing={0.5} direction="row" alignItems="center" justifyContent="end">
          <Button size="small" color="error" onClick={onClose}>
            Cancel
          </Button>
          <Button size="small" variant="contained" type="submit">
            Add
          </Button>
        </Stack>
      </Stack>
    </FormProvider>
  );
};
